import { Tag } from "antd";
import React, { useEffect, useRef, useState } from "react";
import PageTab from "@/components/i-pageTab/i-pageTab";
import PageTable from "@/components/i-pageTable/i-pageTable";
import {businessTypeOptions,amountTypeOptions} from "@/pages/statistics/merAndVipStatisticsList/helps";

import {
  setIcons,
  showModal,
  downloadFile,
  getTimeFormat,
  getFirstDay,
} from "@/utils/common";

import {
  userDailyStatisticsList,
  userDailyStatisticsExport,
  userDailyStatisticsAmount,
} from "@/api/statistics";
import dayjs from "dayjs";
import { userLevelOptions } from "@/utils/enums";

const getYesterday = () => {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return date;
};

const UserDailyStatistics = () => {
  const [pageData, setPageData] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [amountData, setAmountData] = useState<{ earnAmount: number; consumeAmount: number }>({
    earnAmount: 0,
    consumeAmount: 0,
  });

  // 资金类型
  const fundTypeList = amountTypeOptions

  // 业务类型
  const businessTypeList = businessTypeOptions

  // 资金走向
  const fundDirectionList = [
    { label: "赚取", value: 1 },
    { label: "消耗", value: 2 },
  ];

  const [formData, setFormData] = useState<Record<string, any>>({
    startTime: getTimeFormat(getYesterday(), "yyyy-MM-dd 00:00:00"),
    endTime: getTimeFormat(getYesterday(), "yyyy-MM-dd 23:59:59"),
    mobile: "",
    userLevel: "",
    fundType: "",
    businessType: "",
    fundDirection: "",
    ypageNum: 1,
    ypageSize: 10,
  });

  const formTab = [
    {
      label: "用户账号",
      name: "mobile",
      type: "input",
      width: "240px", 
    },
    {
      label: "用户等级",
      name: "userLevel",
      type: "select",
      options: userLevelOptions,
    },
    {
      label: "资金类型",
      name: "amountType",
      type: "select",
      options: fundTypeList,
    },
    {
      label: "业务类型",
      name: "businessType",
      type: "select",
      options: businessTypeList,
    },
    {
      label: "资金走向",
      name: "accountTrend",
      type: "select",
      options: fundDirectionList,
    },
    {
      label: "统计日期",
      name: "rangePicker",
      type: "rangePicker",
      width: "380px",
      defaultValues: [getTimeFormat(getYesterday(), "yyyy-MM-dd 00:00:00"), getTimeFormat(getYesterday(), "yyyy-MM-dd 23:59:59")],
    },
  ];

  const footer = [
    {
      title: "导出",
      icon: setIcons("DownloadOutlined"),
      onClick: () => exportExcel(),
      loading: exportLoading,
    },
     {
      title: "累计",
      render: (
        <div style={{display: 'flex', gap: '24px', marginTop: '6px', marginLeft: '26px'}}>
          <span style={{  fontWeight: "bold" }}>累计赚取：{amountData.earnAmount}</span>
          <span style={{ fontWeight: "bold" }}>累计消耗：{amountData.consumeAmount}</span>
        </div>
      )
     },
  ];

  const columns = [
    {
      title: "用户ID",
      dataIndex: "userId",
      key: "userId",
    },
    {
      title: "用户昵称",
      dataIndex: "nickName",
      key: "nickName",
    },
    {
      title: "用户账号",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "资金类型",
      dataIndex: "amountTypeStr",
      key: "amountTypeStr",
    },
    {
      title: "业务类型",
      dataIndex: "businessTypeStr",
      key: "businessTypeStr",
    },
    {
      title: "资金走向",
      dataIndex: "accountTrendStr",
      key: "accountTrendStr",
      render: (text: string) => <span style={{ color: text === "赚取" ? "red" : "green" }}>{text}</span>,
    },
    {
      title: "金额",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "统计日期",
      dataIndex: "statisticsDate",
      key: "statisticsDate",
    },
  ];

  useEffect(() => {
    getPageData();
    getAmountData();
  }, [formData]);

  const getPageData = async () => {
    setLoading(true);
    try {
      const data = await userDailyStatisticsList(formData);
      setPageData(data.rows);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getAmountData = async () => {
    try {
      const {data} = await userDailyStatisticsAmount(formData);
      setAmountData({
        earnAmount: data.earnAmount || 0,
        consumeAmount: data.costAmount || 0,
      });
    } catch (error) {
    }
  };

  const exportExcel = async () => {
    setExportLoading(true);
    try {
      const data = await userDailyStatisticsExport(formData);
      downloadFile(
        data as any,
        "用户日统计" + getTimeFormat(new Date(), "yyyy-MM-dd HH:mm:ss")
      );
    } catch (error) {
    } finally {
      setExportLoading(false);
    }
  };
  const search = (val: any) => {
    console.log(val, 'val');
    setFormData({
      ...formData,
      ...val,
      ypageNum: 1,
    });
  };

  const reset = () => {
    setFormData({
      startTime: getTimeFormat(getYesterday(), "yyyy-MM-dd 00:00:00"),
      endTime: getTimeFormat(getYesterday(), "yyyy-MM-dd 23:59:59"),
      mobile: "",
      userLevel: "",
      fundType: "",
      businessType: "",
      fundDirection: "",
      ypageNum: 1,
      ypageSize: 10,
    });
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };
  return (
    <div>
      <PageTab
        search={search}
        reset={reset}
        formTab={formTab}
        footer={footer}
      ></PageTab>
  
      <PageTable
        loading={loading}
        pageChange={pageChange}
        rowKey="id"
        columns={columns}
        data={pageData}
        pagination={{
          current: formData.ypageNum!,
          pageSize: formData.ypageSize!,
          total: total,
        }}
      ></PageTable>
    </div>
  );
};

export default UserDailyStatistics;
